import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessions } from '../context/SessionContext';

function OffeneSessionsPage() {
  const { getOpenSessions, deleteSession } = useSessions();
  const navigate = useNavigate();
  const sessions = getOpenSessions();
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const formatDate = (iso) => {
    const d = new Date(iso);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const getPreview = (session) => {
    if (session.summary && Array.isArray(session.summary) && session.summary.length > 0) {
      const firstSection = session.summary[0];
      const items = firstSection.items || [];
      return items.slice(0, 3).join(' • ');
    }
    return 'Keine medizinischen Informationen erfasst';
  };

  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setDeleteConfirmId(id);
  };

  const confirmDelete = () => {
    if (deleteConfirmId) {
      deleteSession(deleteConfirmId);
      setDeleteConfirmId(null);
    }
  };

  return (
    <div className="page page-wide">
      <h1 className="page-title">Offene Konsultationen</h1>
      <p className="page-subtitle">Unterbrochene Konsultationen fortsetzen</p>

      {sessions.length === 0 ? (
        <div className="session-list-empty">
          <p>Keine offenen Konsultationen vorhanden.</p>
          <p className="session-list-empty-hint">Unterbrochene Konsultationen werden hier angezeigt und können fortgesetzt werden.</p>
        </div>
      ) : (
        <div className="session-list">
          {sessions.map((session) => (
            <div
              key={session.id}
              className="session-list-card session-list-card-open"
              onClick={() => navigate(`/analyse/${session.id}`)}
            >
              <div className="session-list-card-header">
                <h3 className="session-list-card-name">{session.name}</h3>
                <span className="session-list-card-date">{formatDate(session.updatedAt)}</span>
              </div>
              <p className="session-list-card-preview">{getPreview(session)}</p>
              <div className="session-list-card-actions">
                <button className="session-list-btn-resume" onClick={(e) => { e.stopPropagation(); navigate(`/analyse/${session.id}`); }}>
                  Fortsetzen
                </button>
                <button className="session-list-btn-delete" onClick={(e) => handleDeleteClick(e, session.id)}>
                  Löschen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {deleteConfirmId && (
        <div className="session-modal-overlay" onClick={() => setDeleteConfirmId(null)}>
          <div className="session-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Konsultation löschen</h3>
            <p style={{ fontSize: '14px', color: '#374151', marginBottom: '16px' }}>
              Möchten Sie diese Konsultation wirklich unwiderruflich löschen?
            </p>
            <div className="session-modal-actions">
              <button className="modal-btn-cancel" onClick={() => setDeleteConfirmId(null)}>
                Abbrechen
              </button>
              <button className="modal-btn-confirm" onClick={confirmDelete} style={{ background: '#dc2626' }}>
                Löschen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OffeneSessionsPage;
